import { Colors } from 'libs/ui/theme';

import { SvgIcon } from '../SvgIcon';
import { SvgProps } from '../types';

export const Bell = ({
  size = 24,
  color = Colors.black,
  className,
}: SvgProps) => (
  <SvgIcon className={className} size={size}>
    <svg
      color={color}
      fill="none"
      height="24"
      viewBox="0 0 24 24"
      width="24"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        color="currentColor"
        d="M14.8852 21C12.881 22.3333 10.2519 22.3333 8.24773 21M4.56658 10C4.56658 6.13401 7.70059 3 11.5666 3C15.4326 3 18.5666 6.13401 18.5666 10V12.5778C18.5666 14.1572 19.0341 15.7013 19.9102 17.0154L20.0483 17.2226C20.2699 17.5549 20.0317 18 19.6323 18H3.50084C3.10149 18 2.8633 17.5549 3.08482 17.2227L3.22298 17.0154C4.09908 15.7013 4.56658 14.1572 4.56658 12.5778V10Z"
        stroke="currentColor"
        strokeLinecap="round"
        strokeWidth="1.5"
      />
    </svg>
  </SvgIcon>
);
